<template>
	<InertiaHead>
        <title>{{ title }}</title>
        <slot name="meta"></slot>
    </InertiaHead>

	<div class="h-screen flex overflow-hidden bg-gray-100">
		<TransitionRoot as="template" :show="sidebarOpen">
			<Dialog as="div" static class="fixed inset-0 flex z-40 md:hidden" @close="sidebarOpen = false" :open="sidebarOpen">
				<TransitionChild as="template" enter="transition-opacity ease-linear duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="transition-opacity ease-linear duration-300" leave-from="opacity-100" leave-to="opacity-0">
					<DialogOverlay class="fixed inset-0 bg-gray-600 bg-opacity-75" />
				</TransitionChild>
				<TransitionChild as="template" enter="transition ease-in-out duration-300 transform" enter-from="-translate-x-full" enter-to="translate-x-0" leave="transition ease-in-out duration-300 transform" leave-from="translate-x-0" leave-to="-translate-x-full">
					<div class="relative flex-1 flex flex-col max-w-xs w-full pt-5 pb-4 bg-indigo-700">
						<TransitionChild as="template" enter="ease-in-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in-out duration-300" leave-from="opacity-100" leave-to="opacity-0">
							<div class="absolute top-0 right-0 -mr-12 pt-2">
								<button type="button" class="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white" @click="sidebarOpen = false">
									<span class="sr-only">Close sidebar</span>
									<XIcon class="h-6 w-6 text-white" aria-hidden="true" />
								</button>
							</div>
						</TransitionChild>
						<div class="flex-shrink-0 flex items-center px-4">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 570 276" class="h-12 text-white ">
                                <path fill="#fff" d="M174.578 249.332h6.504l6.386 14.191 6.386-14.191h6.505L187.468 276l-12.89-26.668ZM225.368 265.829l4.849 2.721c-1.064 1.892-2.602 3.547-4.198 4.553-2.011 1.3-4.672 1.892-7.333 1.892-3.311 0-6.031-.828-8.396-3.193-2.365-2.366-3.666-5.795-3.666-9.52 0-3.844 1.36-7.569 3.961-10.23 2.07-2.07 4.79-3.37 8.338-3.37 3.962 0 6.504 1.714 7.983 3.252 3.193 3.311 3.488 7.923 3.488 10.525v.71h-17.857c.118 1.774.887 3.784 2.129 5.026 1.36 1.36 3.015 1.596 4.434 1.596 1.597 0 2.779-.355 3.962-1.241 1.005-.769 1.774-1.774 2.306-2.721Zm-12.417-7.391h11.53c-.236-1.36-.887-2.542-1.774-3.37-.768-.71-2.01-1.419-3.902-1.419-2.011 0-3.312.827-4.08 1.596-.828.769-1.479 1.951-1.774 3.193ZM240.615 274.226v-24.894h5.795v2.306c2.483-2.779 5.322-2.956 6.741-2.956 4.612 0 6.563 2.306 7.332 3.37.946 1.36 1.537 3.075 1.537 6.918v15.256h-5.794v-13.837c0-6.327-2.366-6.504-4.553-6.504-2.602 0-5.263.355-5.263 8.397v11.944h-5.795ZM284.004 254.654h-4.435v19.572h-5.795v-19.572h-2.424v-5.322h2.424v-9.106h5.795v9.106h4.435v5.322ZM292.141 249.332h5.795v14.251c0 1.478.059 3.193 1.065 4.493.768 1.006 2.128 1.715 3.784 1.715 1.656 0 3.016-.709 3.784-1.715 1.006-1.3 1.065-3.015 1.065-4.493v-14.251h5.795v14.428c0 3.193-.355 5.854-2.661 8.16-2.247 2.247-5.322 3.075-8.101 3.075-2.543 0-5.618-.769-7.865-3.075-2.306-2.306-2.661-4.967-2.661-8.16v-14.428ZM325.007 274.226v-24.894h5.794v2.247c.651-.769 1.597-1.597 2.425-2.07 1.123-.65 2.247-.827 3.548-.827 1.419 0 2.956.236 4.553 1.182l-2.366 5.263c-1.3-.828-2.365-.887-2.956-.887-1.242 0-2.484.177-3.607 1.36-1.597 1.715-1.597 4.08-1.597 5.736v12.89h-5.794ZM364.459 265.829l4.849 2.721c-1.064 1.892-2.602 3.547-4.198 4.553-2.011 1.3-4.672 1.892-7.332 1.892-3.312 0-6.032-.828-8.397-3.193-2.365-2.366-3.666-5.795-3.666-9.52 0-3.844 1.36-7.569 3.962-10.23 2.069-2.07 4.789-3.37 8.337-3.37 3.962 0 6.504 1.714 7.983 3.252 3.193 3.311 3.488 7.923 3.488 10.525v.71h-17.857c.118 1.774.887 3.784 2.129 5.026 1.36 1.36 3.015 1.596 4.434 1.596 1.597 0 2.78-.355 3.962-1.241 1.005-.769 1.774-1.774 2.306-2.721Zm-12.417-7.391h11.53c-.236-1.36-.887-2.542-1.774-3.37-.768-.71-2.01-1.419-3.902-1.419-2.011 0-3.312.827-4.08 1.596-.828.769-1.479 1.951-1.774 3.193ZM394.962 253.057l-4.317 2.839c-.591-.947-1.714-2.129-3.547-2.129-.828 0-1.42.295-1.774.65a1.876 1.876 0 0 0-.533 1.301c0 .651.296 1.064.828 1.419.355.237.71.355 1.952 1.005l2.956 1.479c1.301.65 2.543 1.301 3.489 2.306 1.36 1.36 1.833 2.897 1.833 4.612 0 2.247-.828 4.198-2.188 5.677-1.951 2.128-4.376 2.779-6.977 2.779-1.597 0-3.607-.237-5.381-1.597-1.419-1.064-2.602-2.779-3.193-4.553l4.73-2.247c.296.828.828 1.892 1.36 2.365.355.355 1.183.947 2.543.947.887 0 1.833-.296 2.365-.828.473-.473.828-1.242.828-1.952 0-.709-.237-1.301-.769-1.892-.709-.709-1.537-1.123-2.483-1.537l-2.129-1.005c-1.124-.533-2.484-1.183-3.43-2.129-1.301-1.242-1.774-2.602-1.774-4.198 0-2.011.769-3.962 2.07-5.322 1.123-1.183 3.016-2.365 6.09-2.365 1.774 0 3.194.354 4.613 1.3.828.533 1.951 1.479 2.838 3.075ZM466.212 61.554a57.595 57.595 0 0 0-10.155-2.632 63.402 63.402 0 0 0-10.342-.878c-33.974 0-61.617 27.643-61.617 61.617s26.264 60.614 59.799 61.555H445.464v-24.133c-20.56-.126-37.234-16.925-37.234-37.422 0-20.497 16.799-37.484 37.485-37.484a37.506 37.506 0 0 1 18.867 5.077c11.471 6.707 18.617 19.119 18.617 32.345v25.762c.313 10.217 4.638 19.62 12.348 26.452a36.739 36.739 0 0 0 11.785 7.083v-59.36c0-7.021-1.191-13.853-3.448-20.372-6.143-17.426-20.184-31.53-37.609-37.672l-.063.062ZM284.868 58.044c-33.974 0-61.617 27.643-61.617 61.617 0 3.448.313 6.958.878 10.343a58.245 58.245 0 0 0 2.632 10.217c6.143 17.426 20.247 31.467 37.672 37.61 6.519 2.319 13.415 3.447 20.372 3.447h59.361a35.432 35.432 0 0 0-7.083-11.784c-6.833-7.647-16.235-12.035-26.452-12.286h-25.826c-13.288 0-25.7-7.146-32.344-18.617a37.507 37.507 0 0 1-5.077-18.867c0-20.623 16.799-37.484 37.484-37.484 20.685 0 37.296 16.673 37.484 37.233h24.133v-1.567c-1.003-33.535-28.019-59.8-61.617-59.8v-.062ZM161.387.063v68.825l-17.363-7.459c-3.197-1.128-6.519-1.943-9.841-2.507a63.405 63.405 0 0 0-10.343-.878c-33.974 0-61.617 27.643-61.617 61.617s26.264 60.614 59.799 61.555H123.589v-24.133c-10.217-.063-19.682-4.137-26.702-11.471-7.146-7.397-10.844-17.113-10.468-27.393.69-19.494 16.485-35.29 35.979-36.042 7.209-.25 14.167 1.504 20.31 5.077 11.471 6.707 18.616 19.118 18.616 32.345v25.762c.314 10.217 4.639 19.62 12.349 26.452a36.734 36.734 0 0 0 11.784 7.083l.188-144.734c0-15.796-10.154-29.21-24.258-34.162v.063ZM.353.062.478 147.93a37.68 37.68 0 0 0 .564 3.699 37.073 37.073 0 0 0 11.596 20.246 36.735 36.735 0 0 0 11.785 7.083l.188-144.734C24.61 18.491 14.456 5.014.353.062ZM544.936.188l.125 147.806c.126 1.254.314 2.507.565 3.698 1.567 7.71 5.641 14.919 11.596 20.247a36.734 36.734 0 0 0 11.784 7.083l.188-144.421c0-15.859-10.154-29.335-24.258-34.413Z"></path>
                            </svg>
						</div>
						<div class="mt-10 flex-1 h-0 overflow-y-auto">
							<nav class="px-2 space-y-1">
								<template v-for="(item, index) in navigation" :key="item.name">
                                    <template v-if="! item.roles || item.roles.includes($page.props.auth.user.role)">
                                        <div
                                            v-if="item.group"
                                            class="px-2 mr-4 text-xs font-semibold text-indigo-400 uppercase tracking-wider pb-2"
                                            :class="{ 'pt-5' : index > 0 }"
                                        >
                                            {{ item.name }}
                                        </div>

                                        <InertiaLink v-else :href="item.href" :class="[item.current ? 'bg-indigo-800 text-white' : 'text-indigo-100 hover:bg-indigo-600', 'group flex items-center px-2 py-2 text-base font-medium rounded-md']">
                                            <component :is="item.icon" class="mr-4 flex-shrink-0 h-6 w-6 text-indigo-300" aria-hidden="true" />
                                            {{ item.name }}
                                        </InertiaLink>
                                    </template>
								</template>
							</nav>
						</div>
					</div>
				</TransitionChild>
				<div class="flex-shrink-0 w-14" aria-hidden="true"></div>
			</Dialog>
		</TransitionRoot>

		<!-- Static sidebar for desktop -->
		<div class="hidden bg-secondary bg-pattern md:flex md:flex-shrink-0">
			<div class="flex flex-col w-64">
				<!-- Sidebar component, swap this element with another sidebar if you like -->
				<div class="flex flex-col flex-grow pt-5 pb-4 overflow-y-auto">
					<div class="flex items-center flex-shrink-0 px-4 justify-center mt-2">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 570 276" class="h-12 text-white ">
                            <path fill="#fff" d="M174.578 249.332h6.504l6.386 14.191 6.386-14.191h6.505L187.468 276l-12.89-26.668ZM225.368 265.829l4.849 2.721c-1.064 1.892-2.602 3.547-4.198 4.553-2.011 1.3-4.672 1.892-7.333 1.892-3.311 0-6.031-.828-8.396-3.193-2.365-2.366-3.666-5.795-3.666-9.52 0-3.844 1.36-7.569 3.961-10.23 2.07-2.07 4.79-3.37 8.338-3.37 3.962 0 6.504 1.714 7.983 3.252 3.193 3.311 3.488 7.923 3.488 10.525v.71h-17.857c.118 1.774.887 3.784 2.129 5.026 1.36 1.36 3.015 1.596 4.434 1.596 1.597 0 2.779-.355 3.962-1.241 1.005-.769 1.774-1.774 2.306-2.721Zm-12.417-7.391h11.53c-.236-1.36-.887-2.542-1.774-3.37-.768-.71-2.01-1.419-3.902-1.419-2.011 0-3.312.827-4.08 1.596-.828.769-1.479 1.951-1.774 3.193ZM240.615 274.226v-24.894h5.795v2.306c2.483-2.779 5.322-2.956 6.741-2.956 4.612 0 6.563 2.306 7.332 3.37.946 1.36 1.537 3.075 1.537 6.918v15.256h-5.794v-13.837c0-6.327-2.366-6.504-4.553-6.504-2.602 0-5.263.355-5.263 8.397v11.944h-5.795ZM284.004 254.654h-4.435v19.572h-5.795v-19.572h-2.424v-5.322h2.424v-9.106h5.795v9.106h4.435v5.322ZM292.141 249.332h5.795v14.251c0 1.478.059 3.193 1.065 4.493.768 1.006 2.128 1.715 3.784 1.715 1.656 0 3.016-.709 3.784-1.715 1.006-1.3 1.065-3.015 1.065-4.493v-14.251h5.795v14.428c0 3.193-.355 5.854-2.661 8.16-2.247 2.247-5.322 3.075-8.101 3.075-2.543 0-5.618-.769-7.865-3.075-2.306-2.306-2.661-4.967-2.661-8.16v-14.428ZM325.007 274.226v-24.894h5.794v2.247c.651-.769 1.597-1.597 2.425-2.07 1.123-.65 2.247-.827 3.548-.827 1.419 0 2.956.236 4.553 1.182l-2.366 5.263c-1.3-.828-2.365-.887-2.956-.887-1.242 0-2.484.177-3.607 1.36-1.597 1.715-1.597 4.08-1.597 5.736v12.89h-5.794ZM364.459 265.829l4.849 2.721c-1.064 1.892-2.602 3.547-4.198 4.553-2.011 1.3-4.672 1.892-7.332 1.892-3.312 0-6.032-.828-8.397-3.193-2.365-2.366-3.666-5.795-3.666-9.52 0-3.844 1.36-7.569 3.962-10.23 2.069-2.07 4.789-3.37 8.337-3.37 3.962 0 6.504 1.714 7.983 3.252 3.193 3.311 3.488 7.923 3.488 10.525v.71h-17.857c.118 1.774.887 3.784 2.129 5.026 1.36 1.36 3.015 1.596 4.434 1.596 1.597 0 2.78-.355 3.962-1.241 1.005-.769 1.774-1.774 2.306-2.721Zm-12.417-7.391h11.53c-.236-1.36-.887-2.542-1.774-3.37-.768-.71-2.01-1.419-3.902-1.419-2.011 0-3.312.827-4.08 1.596-.828.769-1.479 1.951-1.774 3.193ZM394.962 253.057l-4.317 2.839c-.591-.947-1.714-2.129-3.547-2.129-.828 0-1.42.295-1.774.65a1.876 1.876 0 0 0-.533 1.301c0 .651.296 1.064.828 1.419.355.237.71.355 1.952 1.005l2.956 1.479c1.301.65 2.543 1.301 3.489 2.306 1.36 1.36 1.833 2.897 1.833 4.612 0 2.247-.828 4.198-2.188 5.677-1.951 2.128-4.376 2.779-6.977 2.779-1.597 0-3.607-.237-5.381-1.597-1.419-1.064-2.602-2.779-3.193-4.553l4.73-2.247c.296.828.828 1.892 1.36 2.365.355.355 1.183.947 2.543.947.887 0 1.833-.296 2.365-.828.473-.473.828-1.242.828-1.952 0-.709-.237-1.301-.769-1.892-.709-.709-1.537-1.123-2.483-1.537l-2.129-1.005c-1.124-.533-2.484-1.183-3.43-2.129-1.301-1.242-1.774-2.602-1.774-4.198 0-2.011.769-3.962 2.07-5.322 1.123-1.183 3.016-2.365 6.09-2.365 1.774 0 3.194.354 4.613 1.3.828.533 1.951 1.479 2.838 3.075ZM466.212 61.554a57.595 57.595 0 0 0-10.155-2.632 63.402 63.402 0 0 0-10.342-.878c-33.974 0-61.617 27.643-61.617 61.617s26.264 60.614 59.799 61.555H445.464v-24.133c-20.56-.126-37.234-16.925-37.234-37.422 0-20.497 16.799-37.484 37.485-37.484a37.506 37.506 0 0 1 18.867 5.077c11.471 6.707 18.617 19.119 18.617 32.345v25.762c.313 10.217 4.638 19.62 12.348 26.452a36.739 36.739 0 0 0 11.785 7.083v-59.36c0-7.021-1.191-13.853-3.448-20.372-6.143-17.426-20.184-31.53-37.609-37.672l-.063.062ZM284.868 58.044c-33.974 0-61.617 27.643-61.617 61.617 0 3.448.313 6.958.878 10.343a58.245 58.245 0 0 0 2.632 10.217c6.143 17.426 20.247 31.467 37.672 37.61 6.519 2.319 13.415 3.447 20.372 3.447h59.361a35.432 35.432 0 0 0-7.083-11.784c-6.833-7.647-16.235-12.035-26.452-12.286h-25.826c-13.288 0-25.7-7.146-32.344-18.617a37.507 37.507 0 0 1-5.077-18.867c0-20.623 16.799-37.484 37.484-37.484 20.685 0 37.296 16.673 37.484 37.233h24.133v-1.567c-1.003-33.535-28.019-59.8-61.617-59.8v-.062ZM161.387.063v68.825l-17.363-7.459c-3.197-1.128-6.519-1.943-9.841-2.507a63.405 63.405 0 0 0-10.343-.878c-33.974 0-61.617 27.643-61.617 61.617s26.264 60.614 59.799 61.555H123.589v-24.133c-10.217-.063-19.682-4.137-26.702-11.471-7.146-7.397-10.844-17.113-10.468-27.393.69-19.494 16.485-35.29 35.979-36.042 7.209-.25 14.167 1.504 20.31 5.077 11.471 6.707 18.616 19.118 18.616 32.345v25.762c.314 10.217 4.639 19.62 12.349 26.452a36.734 36.734 0 0 0 11.784 7.083l.188-144.734c0-15.796-10.154-29.21-24.258-34.162v.063ZM.353.062.478 147.93a37.68 37.68 0 0 0 .564 3.699 37.073 37.073 0 0 0 11.596 20.246 36.735 36.735 0 0 0 11.785 7.083l.188-144.734C24.61 18.491 14.456 5.014.353.062ZM544.936.188l.125 147.806c.126 1.254.314 2.507.565 3.698 1.567 7.71 5.641 14.919 11.596 20.247a36.734 36.734 0 0 0 11.784 7.083l.188-144.421c0-15.859-10.154-29.335-24.258-34.413Z"></path>
                        </svg>
                    </div>
					<div class="mt-8 flex-1 flex flex-col">
						<nav class="flex-1 px-2 space-y-1">
							<template v-for="(item, index) in navigation" :key="item.name">
                                <template v-if="! item.roles || item.roles.includes($page.props.auth.user.role)">
                                    <div
                                        v-if="item.group"
                                        class="px-2 mr-4 text-xs font-semibold text-gray-400 uppercase tracking-wider pb-2 pt-5 first:!pt-0"
                                    >
                                        {{ item.name }}
                                    </div>

                                    <InertiaLink v-else :href="item.href" :class="[item.current ? 'bg-primary text-white' : 'text-gray-100 hover:bg-primary', 'group flex items-center px-2 py-2 text-sm font-medium rounded-md']">
                                        <component :is="item.icon" class="mr-3 flex-shrink-0 h-6 w-6 text-gray-50" aria-hidden="true" />
                                        {{ item.name }}
                                    </InertiaLink>
                                </template>
							</template>
						</nav>
					</div>
				</div>
			</div>
		</div>
		<div class="flex flex-col w-0 flex-1 overflow-hidden">
			<div class="relative z-5 flex-shrink-0 flex h-16 bg-white shadow">
				<button type="button" class="px-4 border-r border-gray-200 text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500 md:hidden" @click="sidebarOpen = true">
					<span class="sr-only">Open sidebar</span>
					<MenuAlt2Icon class="h-6 w-6" aria-hidden="true" />
				</button>
				<div class="flex-1 px-8 flex justify-between">
					<div class="flex-1 flex items-center">
						<h1 class="text-xl font-base text-gray-900">
							<slot name="title"></slot>
						</h1>
						<div class="pl-4">
							<slot name="titleNav"></slot>
						</div>
					</div>
					<div class="ml-4 flex items-center md:ml-6">

						<!-- Profile dropdown -->
						<ClientOnly>
							<Menu as="div" class="ml-3 relative">
								<div>
									<MenuButton class="max-w-xs bg-white flex items-center text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
										<span class="sr-only">Open user menu</span>
										<span class="h-8 w-8 leading-8 rounded-full text-center bg-secondary text-white">{{ user.initials }}</span>
									</MenuButton>
								</div>
								<transition enter-active-class="transition ease-out duration-100" enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100" leave-active-class="transition ease-in duration-75" leave-from-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">
									<MenuItems class="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
										<MenuItem v-for="item in userNavigation" :key="item.name" v-slot="{ active }">
											<InertiaLink :href="item.href" :method="item.method ?? 'get'" :as="item.method === 'post' ? 'button' : 'a'" :class="[active ? 'bg-gray-100' : '', 'block px-4 py-2 text-sm text-gray-700']" class="w-full text-left">{{ item.name }}</InertiaLink>
										</MenuItem>
									</MenuItems>
								</transition>
							</Menu>
						</ClientOnly>
					</div>
				</div>
			</div>

			<main class="flex-1 relative overflow-y-auto focus:outline-none">
				<div class="py-6">
					<div class="mx-auto px-4 sm:px-6 md:px-8">
						<slot></slot>
					</div>
				</div>

				<!-- Global notification live region, render this permanently at the end of the document -->
				<div aria-live="assertive" class="fixed inset-0 flex items-end p-4 z-30 pointer-events-none sm:items-start">
					<div class="w-full flex flex-col items-center space-y-4 sm:items-end">

						<Notification
							v-if="$page.props.flash.success"
							@closed="$page.props.flash.success = null"
						>
							{{ $page.props.flash.success }}
						</Notification>

					</div>
				</div>

                <FileSelector />

			</main>

		</div>
	</div>
</template>

<script>
	import {
		Dialog,
		DialogOverlay,
		Menu,
		MenuButton,
		MenuItem,
		MenuItems,
		TransitionChild,
		TransitionRoot,
	} from '@headlessui/vue'
    import {
        ArrowCircleUpIcon,
        BellIcon,
        CogIcon,
        ClockIcon,
        DesktopComputerIcon, DocumentTextIcon,
        GlobeIcon,
        InboxIcon,
        MenuAlt2Icon,
        ShieldCheckIcon,
        TerminalIcon,
        TranslateIcon,
        UsersIcon,
        XIcon,
        CalendarIcon,
        ClipboardListIcon,
        OfficeBuildingIcon,
    } from '@heroicons/vue/outline'

	export default {
		components: {
			Dialog,
			DialogOverlay,
			Menu,
			MenuButton,
			MenuItem,
			MenuItems,
			TransitionChild,
			TransitionRoot,
            BellIcon,
            DesktopComputerIcon,
            GlobeIcon,
            MenuAlt2Icon,
            ShieldCheckIcon,
            TranslateIcon,
            UsersIcon,
            XIcon,
		},
		props: {
			title: String,
		},
		data() {
			return {
				navigation: [
                    {
                        name: this.__('admin::nav.group_platform'),
                        group: true,
                        roles: ['admin', 'hr_manager'],
                    },
                    {
                        name: this.__('admin::nav.users'),
                        href: this.$route('admin::users.index'),
                        icon: ShieldCheckIcon,
                        roles: ['admin', 'hr_manager'],
                    },
                    {
                        name: this.__('admin::nav.time_entries'),
                        href: this.$route('admin::time-entries.index'),
                        icon: ClockIcon,
                        roles: ['admin', 'hr_manager'],
                    },
                    {
                        name: this.__('admin::nav.companies'),
                        href: this.$route('admin::companies.index'),
                        icon: OfficeBuildingIcon,
                        roles: ['admin', 'hr_manager'],
                    },
                    {
                        name: this.__('admin::nav.vacation_requests'),
                        href: this.$route('admin::vacation-requests.index'),
                        icon: ClipboardListIcon,
                        roles: ['admin', 'hr_manager'],
                    },
                    {
                        name: this.__('admin::nav.reminders'),
                        href: this.$route('admin::reminders.index'),
                        icon: ClockIcon,
                        roles: ['admin'],
                    },
                    {
                        name: this.__('admin::nav.signatures'),
                        href: this.$route('admin::signatures.index'),
                        icon: InboxIcon,
                        roles: ['admin'],
                    },
                    {
                        name: this.__('admin::nav.vacation_message_defaults'),
                        href: this.$route('admin::vacation-message-defaults.index'),
                        icon: DocumentTextIcon,
                        roles: ['admin'],
                    },
                    /*
                    {
                        name: this.__('admin::nav.settings'),
                        href: this.$route('admin::settings.index'),
                        icon: CogIcon,
                        roles: ['admin'],
                    },
                    */
					{
						name: this.__('admin::nav.group_content'),
						group: true,
                        roles: ['admin'],
					},
					{
						name: this.__('admin::nav.texts_and_translations'),
						href: this.$route('admin::language-lines.index'),
						icon: TranslateIcon,
                        roles: ['admin'],
					},
					{
						name: this.__('admin::nav.languages'),
						href: this.$route('admin::languages.index'),
						icon: GlobeIcon,
                        roles: ['admin'],
					},
                    {
                        name: this.__('admin::nav.group_for_you'),
                        group: true,
                        roles: null,
                    },
                    {
                        name: this.__('admin::nav.my_vacations'),
                        href: this.$route('admin::my-vacations.index'),
                        icon: CalendarIcon,
                        roles: null,
                    },
                    {
                        name: this.__('admin::nav.my_time_entries'),
                        href: this.$route('admin::my-time-entries.index'),
                        icon: ClockIcon,
                        roles: null,
                    },
                    {
                        name: this.__('admin::nav.my_profile'),
                        href: this.$route('admin::profile.edit'),
                        icon: ShieldCheckIcon,
                        roles: null,
                    },
				],
				userNavigation: [
					{
						name: this.__('admin::nav.my_profile'),
						href: this.$route('admin::profile.edit'),
					},
					{
						name: this.__('admin::nav.sign_out'),
						href: this.$route('admin::auth.destroy'),
						method: 'post',
					},
				],
				user: this.$page.props.auth.user,
				sidebarOpen: false,
			};
		},
	}
</script>
